import Alpine from 'alpinejs'

export default (limit) => ({
	// METHODS
	async load() {
		const { productId, sectionId } = this.$el.dataset;
		if (!productId || !sectionId) return;

		// Fetch recommendation markup.
		const response = await fetch(`${routes.productRecommendationsURL}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`)

		// If response error, stop.
		if (!response.ok) {
			console.error(response.status);
			return false;
		}

		const text = await response.text();

		// Update recommendations markup.
		const el = this.$el.querySelector('.js-contents');
		const newHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('.js-contents').outerHTML;

		Alpine.morph(el, newHTML);
	},
})
